export enum PromptType {
  ADD_EMAIL = 'ADD_EMAIL',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD'
}

export enum ViewType {
  POP_UP = 'POP_UP',
  BANNER = 'BANNER'
}

export enum DismissOption {
  TEMPORARY_ONLY = 'TEMPORARY_ONLY',
  TEMPORARY_OR_FOREVER = 'TEMPORARY_OR_FOREVER'
}
